/**
 * Single source of truth for store contact + delivery details.
 *
 * IMPORTANT: `whatsapp` must be the full international number in DIGITS ONLY
 * (no +, spaces or dashes) — it is dropped straight into a wa.me link. Swap the
 * placeholder below for the real store number and the whole order/contact flow
 * points at it.
 */
export const storeInfo = {
  name: 'Ayat Fragrances',

  // 92 = Pakistan country code, then the mobile number without the leading 0.
  // TODO: replace with the real WhatsApp business number (digits only).
  whatsapp: '923000000000',
  // TODO: replace with the real phone number shown on the Contact page.
  phoneDisplay: '+92 300 0000000',
  // TODO: replace with the real store email address.
  email: 'orders@ayatfragrances.com',

  // TODO: replace with the real studio/store address.
  address: 'Pakistan',
  city: 'Pakistan',
  hours: 'Mon–Sat, 11am – 8pm (PKT)',

  // TODO: replace each URL with the real social profile link.
  // Admin-controlled from Settings → Socials. Empty = hidden in the footer.
  socials: {
    instagram: '',
    tiktok: '',
    facebook: '',
    youtube: '',
    twitter: '',
  },

  // Hero stats beside the home headline (admin-editable in Settings). The live
  // scent count is prepended by the Hero itself.
  homeHero: {
    stats: [
      { value: '24h', label: 'Lasting trail' },
      { value: '100%', label: 'Extrait de parfum' },
    ],
  },

  // Delivery / COD policy (PKR).
  freeShippingThreshold: 5000,
  shippingFee: 250,
  codFee: 0,
  deliveryDays: '2–4 working days',
};

/** Shipping charge for a given subtotal (free above the threshold). */
export function shippingFor(subtotal) {
  return subtotal >= storeInfo.freeShippingThreshold ? 0 : storeInfo.shippingFee;
}
